import { render, staticRenderFns } from "./AthleteAppSvg.vue?vue&type=template&id=6ee19fa6&"
import script from "./AthleteAppSvg.vue?vue&type=script&lang=ts&"
export * from "./AthleteAppSvg.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports